module.exports = __webpack_public_path__ + "img/dot.25ea1de8.png";